// tools/gen-sdf.ts が生成。直接編集しない。
export const SDF = {
  /** 場の実体。内容ハッシュ入りの名前なので immutable キャッシュできる。 */
  bin: "sdf-a38e46fc.bin",
  width: 578,
  height: 256,
  /**
   * R: 0.5 が輪郭。テクセル距離への復号は
   * d = sign(v - 0.5) * (2 * |v - 0.5|)^2 * range
   */
  range: 96,
  /** G: ドリップ場が届く最大テクセル数。 */
  dripMax: 64,
  /** 文字列を囲む矩形（テクセル座標、y は下向き）。 */
  box: { x: 74.72, y: 56.42, w: 428.55, h: 107.52 },
} as const;
